var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueGass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.997,
    x2: 92.127,
    xlinkHref: "#lg1",
    y1: 158.324,
    y2: 203.112
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 1 164.181 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -305.823,
    x2: -253.692,
    xlinkHref: "#lg1",
    y1: 158.324,
    y2: 203.112
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 258.942,
    y2: 311.077
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.747,
    x2: 182.359,
    xlinkHref: "#lg1",
    y1: 302.575,
    y2: 464.839
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.633,
    x2: 64.269,
    xlinkHref: "#lg1",
    y1: 429.909,
    y2: 242.68
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.287,
    x2: 169.312,
    y1: 288.538,
    y2: 373.563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.71,
    x2: 501.929,
    xlinkHref: "#lg1",
    y1: 256.475,
    y2: 429.695
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-1 0 0 1 271.181 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -40.186,
    x2: -174.55,
    xlinkHref: "#lg1",
    y1: 429.909,
    y2: 242.68
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.774,
    x2: 442.934,
    y1: 271.044,
    y2: 386.679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m101.758 90.507c-15.51 0-29.518 9.27-35.58 23.546l-60.533 142.556h41.851l52.077-122.641h2.185c12.002 0 21.731-9.729 21.731-21.731 0-12.001-9.729-21.73-21.731-21.73z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.242 90.507c15.51 0 29.518 9.27 35.58 23.546l60.534 142.556h-41.851l-52.077-122.641h-2.185c-12.002 0-21.731-9.729-21.731-21.731-.001-12.001 9.728-21.73 21.73-21.73z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216.334 243.783h77.331v77.331h-77.331z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m186.459 419.493h-148.994c-13.31 0-24.434-10.128-25.68-23.379l-11.67-124.124c-1.423-15.132 10.481-28.208 25.68-28.208h195.374c17.076 0 29.439 16.294 24.84 32.74l-34.71 124.124c-3.116 11.142-13.27 18.847-24.84 18.847z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.42 401.764h-118.142c-10.554 0-19.375-8.084-20.363-18.661l-9.253-99.076c-1.128-12.079 8.311-22.515 20.363-22.515h154.918c13.54 0 23.343 13.006 19.697 26.133l-27.523 99.076c-2.471 8.893-10.523 15.043-19.697 15.043z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.578 390.75h-99.587c-8.896 0-16.332-6.814-17.165-15.73l-7.8-83.516c-.951-10.182 7.006-18.979 17.165-18.979h130.588c11.414 0 19.677 10.964 16.603 22.029l-23.2 83.516c-2.083 7.497-8.87 12.68-16.604 12.68z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m323.541 419.493h148.994c13.31 0 24.434-10.128 25.68-23.379l11.669-124.124c1.423-15.132-10.481-28.208-25.68-28.208h-195.373c-17.076 0-29.439 16.294-24.84 32.74l34.71 124.124c3.116 11.142 13.27 18.847 24.84 18.847z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.58 401.764h118.142c10.554 0 19.375-8.084 20.363-18.661l9.253-99.076c1.128-12.079-8.311-22.515-20.362-22.515h-154.919c-13.54 0-23.343 13.006-19.697 26.133l27.523 99.076c2.471 8.893 10.523 15.043 19.697 15.043z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.422 390.75h99.588c8.896 0 16.332-6.814 17.165-15.73l7.8-83.516c.951-10.182-7.006-18.979-17.165-18.979h-130.589c-11.414 0-19.677 10.964-16.603 22.029l23.2 83.516c2.083 7.497 8.87 12.68 16.604 12.68z",
    fill: "url(#SVGID_9_)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGass);
export default __webpack_public_path__ + "static/media/blueGass.490bd95936088fe688ecd19b41b6e91a.svg";
export { ForwardRef as ReactComponent };